module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/ligne14-eccf072b30a5c12ead810c1211ede566.png";